export default "__VITE_ASSET__BEldAdkq__"